import { render } from "./ChannelsPage.vue?vue&type=template&id=ce8de40a&scoped=true&ts=true"
import script from "./ChannelsPage.vue?vue&type=script&lang=ts"
export * from "./ChannelsPage.vue?vue&type=script&lang=ts"

import "./ChannelsPage.vue?vue&type=style&index=0&id=ce8de40a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce8de40a"]])

export default __exports__